export const environment = {
  production: false,
  stage: true,
  firebase: {
    apiKey: 'AIzaSyCCzB4Z9voPat_yyK2B10wPGUtL2gTupR8',
    authDomain: 'extravega-management-dev.firebaseapp.com',
    databaseURL: 'https://extravega-management-dev.firebaseio.com',
    projectId: 'extravega-management-dev',
    storageBucket: 'extravega-management-dev.appspot.com',
    messagingSenderId: '705439898344'
  },
  clientId: '705439898344-ksbr4hms6mqk8jcs4p9kh4l6s8fp5ner.apps.googleusercontent.com',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts